/**
 * @desc 查看已绑定维度及数据
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainRoleDimensionResponseDto>;
export function request(roleCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/role/dimension/${roleCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
